<template>
  <div>
    <van-nav-bar
      title="登录"
      right-text="注册"
      right-arrow
      @click-right="$router.push('/client-register')"
    />
    <van-form validate-first @submit="handleLoginClient">
      <van-col :span="24">
        <base-input v-model="form.mobile" type="digit" size="large" label="手机号"
                    maxlength="11" :rules="[{ validator: validMobile, message: '请输入正确的手机号' }]"
        />
      </van-col>
      <van-col :span="24">
        <base-input v-model="form.password" type="password" size="large" label="密码"
                    minlength="6" :rules="[{ validator: validPwd, message: '请输入正确的密码' }]"
        />
      </van-col>
      <van-col :span="22" :offset="1">
        <br>
        <base-button size="large" native-type="submit" :round="true">登 录</base-button>
      </van-col>
      <van-col :span="24" style="text-align: center;">
        <br>
        <div style="color: #ccc; font-size: 0.8rem;">
          请使用您注册的手机号和密码进行登录！<br>
          如您在御茶膳房登记的手机号有变更，请及时联系客服人员！
        </div>
      </van-col>
    </van-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        mobile: '',
        password: ''
      }
    }
  },
  methods: {
    validMobile(val) {
      return /\d{11}/.test(val)
    },
    validPwd(val) {
      return String(val).length >= 6
    },
    handleLoginClient() {
      this.$store.dispatch('user/clientTermLogin', this.form).then(() => {
        this.$router.push('/client-index')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/client/client-login.vue